// extracted by mini-css-extract-plugin
export default {"dateTextIn":"ExpirationValuesInDays_dateTextIn__fiDIB","dateTextSoon":"ExpirationValuesInDays_dateTextSoon__2a+RM"};